export default __webpack_public_path__ + "images/ae6a09dc98fd0b00a2962d34e191f1f4-4_4K_1920x544.jpg";